import React from "react";
import { PERFORMANCE_UNAVAILABLE_MESSAGE } from "../utils/portfolioUtils";

interface PerformanceUnavailableMessageProps {
  isDarkMode?: boolean;
  variant?: "card" | "inline";
  className?: string;
}

const PerformanceUnavailableMessage: React.FC<PerformanceUnavailableMessageProps> = ({
  isDarkMode = false,
  variant = "inline",
  className = "",
}) => {
  if (variant === "card") {
    return (
      <div className={`text-center py-8 ${className}`}>
        <p className={`${isDarkMode ? "text-gray-400" : "text-gray-600"}`}>
          {PERFORMANCE_UNAVAILABLE_MESSAGE}
        </p>
      </div>
    );
  }

  // inline variant - for discover page cards
  return (
    <p
      className={`text-xs max-w-[320px] ${isDarkMode ? "text-gray-400" : "text-gray-500"} ${className}`}
    >
      {PERFORMANCE_UNAVAILABLE_MESSAGE}
    </p>
  );
};

export default PerformanceUnavailableMessage;
